import { Dropdown, Option } from "@fluentui/react-components";
import { useTaxonomyOptions } from "hooks/useTaxonomyOptions";
import { useAtom } from "jotai";
import { ETaxonomy } from "library/types";
import React from "react";
import { filterPaymentTypeAtom } from "store/UIHrPageDashboard";
import { useTranslation } from "react-i18next";

const FilterPaymentType = () => {
  const paymentTypeOptions = useTaxonomyOptions(ETaxonomy.PaymentType);
  const [filterPaymentType, setFilterPaymentType] = useAtom(
    filterPaymentTypeAtom
  );
  const { t } = useTranslation();

  const handleOptionSelect = (ev, data) => {
    if (data.optionValue === "") {
      setFilterPaymentType({
        code: "PaymentType.All",
        text: "",
        value: "",
      });
      return;
    }
    setFilterPaymentType(
      paymentTypeOptions.find((e) => e.value === data.optionValue)
    );
  };

  // The "All" entry carries no text of its own (see filterPaymentTypeAtom) —
  // translate it here so it survives load order and language changes.
  const selectedText =
    filterPaymentType?.value === ""
      ? t("hbh.filterPaymentType.all")
      : filterPaymentType?.text || "";

  return (
    <Dropdown
      data-help="hr-summary-payment-type"
      placeholder={t("hbh.filterPaymentType.placeholder")}
      title={t("hbh.filterPaymentType.title")}
      style={{ marginTop: "10px" }}
      value={selectedText}
      onOptionSelect={handleOptionSelect}
    >
      <Option key={"All"} defaultChecked={true} value="">
        {t("hbh.filterPaymentType.all")}
      </Option>
      {paymentTypeOptions
        .sort((a, b) => a.text.localeCompare(b.text))
        .map((option) => (
          <Option key={option.code} value={option.value}>
            {option.text}
          </Option>
        ))}
    </Dropdown>
  );
};

export default FilterPaymentType;
